<template lang="html">
  <div class="edit-site-facebook-pixel tier tier-three">
    <div class="tier-content">
      <Tooltip content="Add your Facebook pixel to retarget users on Facebook" />

      <Notification
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type"/>

      <Tabs :headings="['Your Pixel ID', 'Connect Account']">
        <Tab>
          <div>
            <SiteFacebookPixelForm
              @submit="submitSite"
              v-model="site"
              :errors="errors"
            />
          </div>
        </Tab>

        <Tab>
          <div>
            <p>
              Log in to Facebook and go to your <a href="https://www.facebook.com/ads/manager" target="_blank">Ads Manager account</a>.
            </p>
            <p>Open the Navigation Bar and select Events Manager.</p>
            <p>Copy your Pixel ID from underneath your Site Name and paste the number into the <strong>Your Pixel ID</strong> tab.</p>

            <hr>

            <div class="helper-text">
              <p>To check if your pixel events are firing as expected, we recommend downloading the <a href="https://chrome.google.com/webstore/detail/facebook-pixel-helper/fdgfkebogiimcoedlicjlajpkdmockpc" target="_blank">Facebook Pixel Helper</a> Google Chrome extension.</p>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {updateCompanySiteData, readCompanySiteData} from '@/lib/sites'

import SiteFacebookPixelForm from '@/components/forms/SiteFacebookPixelForm'
import Tooltip from '@/components/Tooltip'
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'

export default {
  name: 'EditSiteFacebookPixel',

  components: {
    SiteFacebookPixelForm,
    Tooltip,
    Tabs,
    Tab
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      errors: {}
    }
  },

  computed: {
    title() {
      return `Editing ${this.site.name} Facebook Pixel`
    }
  },

  methods: {
    submitSite() {
      updateCompanySiteData(this.companyId, this.siteId, this.site)
        .then(({data}) => {
          this.$emit('updatePage')
          this.triggerNotification('success', 'Facebook Pixel', 'updated')
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
